export function getWikiaContext(): object {
	return {
		enabled: false,
		slots: {
			leader_top: {
				sizes: [[728, 90]],
			},
			leader_plus_top: {
				sizes: [[728, 90]],
			},
			mpu_top: {
				sizes: [[300, 250]],
			},
			mpu_bottom: {
				sizes: [[300, 250]],
			},
			leader_bottom: {
				sizes: [[728, 90]],
			},
			'mobile-banner': {
				sizes: [[320, 50]],
			},
		},
	};
}
